/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import {
  Card,
  Image,
  Navbar,
  Button,
  ButtonGroup,
  Container,
} from 'react-bootstrap';
import { ButtonWithIcon } from '@vlinder-web/button-v2-widget-react';
import { MapWidget } from '../MapWidget';

export interface IMapViewerProps {
  title?: string;
  closeTitleLabel?: string;
  closeModal?(): void;
  accessToken?: string;
  center?: any;
  markers?: any;
}

export const MapViewer = ({
  title,
  closeTitleLabel,
  closeModal,
  accessToken,
  markers,
  center,
}: IMapViewerProps) => {
  if (accessToken && markers) {
    //@ts-ignore
    return (
      <>
        <Navbar
          variant="dark"
          bg="dark"
          fixed={'top'}
          className="navbar-transparent navbar-theme-primary"
        >
          <Container className="position-relative justify-content-between px-3">
            {title ? (
              <Navbar.Brand>
                <div>
                  <span>{title}</span>
                </div>
              </Navbar.Brand>
            ) : (
              <div />
            )}
            <div className="d-block mb-4 mb-md-0 justify-content-end">
              <ButtonGroup className="ms-2 ms-lg-3 p-sm-2 p-md-3">
                <ButtonWithIcon
                  title={closeTitleLabel}
                  icon={'XIcon'}
                  iconPosition={'left'}
                  onClick={closeModal}
                  className="bg-secondary"
                />
              </ButtonGroup>
            </div>
          </Container>
        </Navbar>
        <div style={{ width: '500px', display: 'flex' }}>
          <MapWidget
            accessToken={accessToken}
            center={center}
            markers={markers}
          />
        </div>
      </>
    );
  }
  return null;
};

MapViewer.defaultProps = {};
